export default {
  'movementOsXFinancial.form.selectReportType': 'Selecione o tipo de relatório',
  'movimentOsXFinancial.form.reportType.noFinancialDivergentValue': 'Sem Financeiro / Valor Divergente',
  'movimentOsXFinancial.form.reportType.overview': 'Visão Geral',
  'movimentOsXFinancial.form.reportType.filterByDateFrom': 'Filtrar por data de',
  'movimentOsXFinancial.form.reportType.delivery': 'Entrega',
  'movimentOsXFinancial.form.reportType.authorization': 'Autorização',
  'movimentOsXFinancial.form.reportType.closure': 'Fechamento',
  'movimentOsXFinancial.form.reportType.compareDivergentValue': 'Comparar valor divergente da OS com o valor da parcela',
  'movimentOsXFinancial.form.reportType.grossValue': 'Valor Bruto',
  'movimentOsXFinancial.form.reportType.netValue': 'Valor líquido',
  'movimentOsXFinancial.form.reportType.onlyTtheUnregistered': 'Somente OS sem registro no financeiro',
  'movimentOsXFinancial.form.overview.filterByDate.os': 'OS',
  'movimentOsXFinancial.form.overview.filterByDate.financial': 'Financeiro',
  'movimentOsXFinancial.form.overview.filterBudgetBy': 'Filtrar orçamento por',
  'movimentOsXFinancial.form.overview.filterBudgetBy.delivery': 'Entrega',
  'movimentOsXFinancial.form.overview.filterBudgetBy.authorization': 'Autorização',
  'movimentOsXFinancial.form.overview.filterBudgetBy.closure': 'Fechamento',
  'movimentOsXFinancial.form.overview.filterBudgetBy.issue': 'Emissão',
  'movimentOsXFinancial.form.overview.filterBudgetBy.dueDate': 'Vencimento',
  'movimentOsXFinancial.form.overview.filterBudgetBy.receipt': 'Recebimento',
  'movimentOsXFinancial.form.overview.moreOptions.title': 'Mais Opções',
  'movimentOsXFinancial.form.overview.moreOptions.employees': 'Funcionários',
  'movimentOsXFinancial.form.overview.moreOptions.documentType': 'Tipo de Documento',
};

